import dayjs from "dayjs";
import { isArray, isDate, isObject, mapValues } from "lodash";

export const mapObject = (input: any, callback: (value: any) => any): any => {
    if (isArray(input)) {
        return input.map((value) => mapObject(value, callback));
    }

    // Dates are also objects but shouldn't be traversed.
    if (isDate(input) || dayjs.isDayjs(input)) {
        return callback(input);
    }

    if (isObject(input)) {
        return mapValues(input, (value) => {
            if (isArray(value)) {
                return (value as any[]).map((value) => mapObject(value, callback));
            }

            // Dates are also objects but shouldn't be traversed.
            if (isDate(value) || dayjs.isDayjs(value)) {
                return callback(value);
            }

            if (isObject(value)) {
                return mapObject(value, callback);
            }

            return callback(value);
        });
    }

    return callback(input);
};
